/* Content-only compatibility routing. Keep attribution, preview and locale context. */
(() => {
  const config = document.querySelector('[data-store-content-route]');
  if (!config) return;
  const target = new URL(config.dataset.storeContentRoute, location.origin);
  const incoming = new URL(location.href);
  if (target.origin !== incoming.origin) return;
  const params = new URLSearchParams(incoming.search);
  params.delete('view');
  for (const key of new Set(target.searchParams.keys())) {
    params.delete(key);
    for (const value of target.searchParams.getAll(key)) params.append(key, value);
  }
  target.search = params.toString();
  target.hash = incoming.hash;
  if (target.href !== incoming.href) location.replace(target.pathname + target.search + target.hash);
})();
